import React from "react";
import { Verbindungsabbruch } from "./Verbindungsabbruch";
import { Hauptmenue } from "./Hauptmenue";
import { Meldung } from "./Meldung";
import { Eingabeformular } from "./Eingabeformular";
import { Administration } from "./Administration";
import { Bestaetigungsformular } from "./Bestaetigungsformular";

const beep = new Audio("data:audio/wav;base64,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");
beep.volume = 1.0;
const passwort = "Alestorm7thRum!";
const initialAlarm = false;
const initialAlarmNikolaus = false;
const initialAlarmLothar = false;
const initialKollegium = [
  {
    id: 0,
    vorname: "",
    nachname: "",
    paraphe: "",
    meldung: false,
    standort: true,
    unterricht: false,
    kurs: "",
    schuelerVermisst: 0,
    schuelerRaum: ""
  }
];
const initialMeldung = {
  id: 0,
  standort: true,
  unterricht: false,
  jahrgang: " 5",
  klasse: "a",
  klassenstaerke: true,
  kurs: "",
  schuelerVermisst: 0,
  schuelerRaum: ""
}

export class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      verbindungsabbruch: true,
      counter: 0,
      alarm: initialAlarm,
      alarmNikolaus: initialAlarmNikolaus,
      alarmLothar: initialAlarmLothar,
      kollegium: initialKollegium,
      intervalId: null,
      updateAlarm1: false,
      updateAlarm2: false,
      updateKollegium1: false,
      updateKollegium2: false,
      sortingKey: "nachname",
      ascending: true,
      aktivesMenue: "Hauptmenü",
      eingabewert: "",
      meldung: {
        id: initialMeldung.id,
        standort: initialMeldung.standort,
        unterricht: initialMeldung.unterricht,
        jahrgang: initialMeldung.jahrgang,
        klasse: initialMeldung.klasse,
        klassenstaerke: initialMeldung.klassenstaerke,
        kurs: initialMeldung.kurs,
        schuelerVermisst: initialMeldung.schuelerVermisst,
        schuelerRaum: initialMeldung.schuelerRaum
      }
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  };

  componentDidMount() {
    this.update();
    const id = setInterval(this.update, 5000);
    this.setState({
      intervalId: id
    });
  };

  componentDidUpdate() {
  };

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  };

  handleClick(event) {
    if (event.target.name === "Meldung") {
      this.readKollegium("nachname", true);
      this.setState(state => {
        if (state.meldung.id === 0) {
          return ({
            aktivesMenue: "Meldung",
            meldung: {
              ...this.state.meldung,
              id: state.kollegium[0].id
            }
          });
        }
        else {
          return ({
            aktivesMenue: "Meldung"
          });
        };
      });
    }
    else if (event.target.name === "Hauptmenü") {
      this.setState({
        aktivesMenue: "Hauptmenü"
      });
    }
    else if (event.target.name === "Meldung Senden") {
      this.setState(state => {
        if (state.meldung.id === 0) {
          state.meldung.id = state.kollegium[0].id;
        };
        const index = state.kollegium.findIndex(lehrer => lehrer.id === state.meldung.id);
        if (index === -1) {
          beep.play();
          alert("Fehler: Lehrer existiert nicht in Datenbank!");
          return ({
            aktivesMenue: "Meldung"
          });
        }
        else {
          if (state.kollegium[index].meldung) {
            beep.play();
            alert("Fehler: Meldung dieses Lehrers bereits gesendet!");
            return ({
              aktivesMenue: "Meldung"
            });
          }
          else {
            if (state.meldung.unterricht) {
              let klasse = state.meldung.klasse;
              if (state.meldung.jahrgang === "EF" || state.meldung.jahrgang === "Q1" || state.meldung.jahrgang === "Q2" || state.meldung.jahrgang === "X") {
                klasse = "";
              }
              else if (state.meldung.jahrgang === "VK") {
                if (state.meldung.klasse === "a") {
                  klasse = "01";
                }
                else if (state.meldung.klasse === "b") {
                  klasse = "02";
                }
                else if (state.meldung.klasse === "c") {
                  klasse = "03";
                }
                else if (state.meldung.klasse === "d") {
                  klasse = "04";
                }
                else if (state.meldung.klasse === "e") {
                  klasse = "05";
                };
              };
              this.updateMeldung({
                id: state.meldung.id.toString(),
                meldung: true,
                standort: state.meldung.standort,
                unterricht: state.meldung.unterricht,
                kurs: state.meldung.jahrgang + klasse + " " + state.meldung.kurs,
                schuelerVermisst: state.meldung.schuelerVermisst,
                schuelerRaum: state.meldung.schuelerRaum
              });
            }
            else {
              this.updateMeldung({
                id: state.meldung.id.toString(),
                meldung: true,
                standort: state.meldung.standort,
                unterricht: state.meldung.unterricht,
                kurs: "",
                schuelerVermisst: 0,
                schuelerRaum: ""
              });
            };
          };
        };
      });
    }
    else if (event.target.name === "Administration") {
      this.setState({
        aktivesMenue: "Passworteingabe",
        eingabewert: ""
      });
    }
    else if (event.target.name === "Alarm") {
      this.setState(state => {
        if (!state.alarm) {
          this.updateDoc("system", 0, "alarm", true);
          return ({
            alarm: true
          });
        }
        else {
          this.updateDoc("system", 0, "alarm", false);
          this.updateDoc("system", 0, "alarmNikolaus", false);
          this.updateDoc("system", 0, "alarmLothar", false);
          return ({
            alarm: false,
            alarmNikolaus: false,
            alarmLothar: false
          });
        };
      });
    }
    else if (event.target.name === "Alarm Nikolaus") {
      this.setState(state => {
        this.updateDoc("system", 0, "alarmNikolaus", !state.alarmNikolaus);
        return ({
          alarmNikolaus: !state.alarmNikolaus
        });
      });
    }
    else if (event.target.name === "Alarm Lothar") {
      this.setState(state => {
        this.updateDoc("system", 0, "alarmLothar", !state.alarmLothar);
        return ({
          alarmLothar: !state.alarmLothar
        });
      });
    }
    else if (event.target.name === "Reset") {
      this.setState({
        aktivesMenue: "BestaetigungReset"
      });
    }
    else if (event.target.name === "Reset Ja") {
      this.resetMeldungen();
      this.setState({
        aktivesMenue: "Administration"
      });
    }
    else if (event.target.name === "Reset Nein") {
      this.setState({
        aktivesMenue: "Administration"
      });
    }
    else if (event.target.name === "Lehrer Hinzufügen") {
      this.createLehrer();
    }
    else if (event.target.name.substring(0, 16) === "Lehrer Entfernen") {
      const index = parseInt(event.target.name.substring(16));
      this.deleteDoc("kollegium", this.state.kollegium[index].id);
    };
  };

  handleChange(event) {
    if (event.target.name === "Passwort Eingabe") {
      this.setState({
        eingabewert: event.target.value
      });
    }
    else if (event.target.name === "Lehrer Wahl") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          id: parseInt(event.target.value)
        }
      });
    }
    else if (event.target.name === "Standort Wahl") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          standort: event.target.value === "true"
        }
      });
    }
    else if (event.target.name === "Unterricht Wahl") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          unterricht: event.target.checked
        }
      });
    }
    else if (event.target.name === "Jahrgang Wahl") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          jahrgang: event.target.value
        }
      });
    }
    else if (event.target.name === "Klasse Wahl") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          klasse: event.target.value
        }
      });
    }
    else if (event.target.name === "Klassenstärke Wahl") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          klassenstaerke: event.target.checked
        }
      });
    }
    else if (event.target.name === "Kurs Eingabe") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          kurs: event.target.value
        }
      });
    }
    else if (event.target.name === "Schüler Vermisst Wahl") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          schuelerVermisst: parseInt(event.target.value)
        }
      });
    }
    else if (event.target.name === "Schüler Raum Eingabe") {
      this.setState({
        meldung: {
          ...this.state.meldung,
          schuelerRaum: event.target.value
        }
      });
    }
    else if (event.target.name === "Sortierung Wahl") {
      this.readKollegium(event.target.value.substring(1), event.target.value.substring(0, 1) === "a");
      this.setState({
        sortingKey: event.target.value.substring(1),
        ascending: event.target.value.substring(0, 1) === "a"
      });
    }
    else if (event.target.name.substring(0, 16) === "1Vorname Eingabe") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(16));
        this.updateDoc("kollegium", state.kollegium[index].id, "vorname", event.target.value);
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              vorname: event.target.value
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 17) === "1Nachname Eingabe") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(17));
        this.updateDoc("kollegium", state.kollegium[index].id, "nachname", event.target.value);
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              nachname: event.target.value
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 16) === "1Paraphe Eingabe") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(16));
        this.updateDoc("kollegium", state.kollegium[index].id, "paraphe", event.target.value);
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              paraphe: event.target.value
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 13) === "1Meldung Wahl") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(13));
        this.updateDoc("kollegium", state.kollegium[index].id, "meldung", event.target.checked);
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              meldung: event.target.checked
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 14) === "1Standort Wahl") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(14));
        this.updateDoc("kollegium", state.kollegium[index].id, "standort", event.target.value === "true");
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              standort: event.target.value === "true"
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 16) === "1Unterricht Wahl") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(16));
        this.updateDoc("kollegium", state.kollegium[index].id, "unterricht", event.target.checked);
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              unterricht: event.target.checked
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 13) === "1Kurs Eingabe") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(13));
        this.updateDoc("kollegium", state.kollegium[index].id, "kurs", event.target.value);
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              kurs: event.target.value
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 22) === "1Schüler Vermisst Wahl") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(22));
        this.updateDoc("kollegium", state.kollegium[index].id, "schuelerVermisst", parseInt(event.target.value));
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              schuelerVermisst: parseInt(event.target.value)
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    }
    else if (event.target.name.substring(0, 21) === "1Schüler Raum Eingabe") {
      this.setState(state => {
        const index = parseInt(event.target.name.substring(21));
        this.updateDoc("kollegium", state.kollegium[index].id, "schuelerRaum", event.target.value);
        return ({
          kollegium: [
            ...state.kollegium.slice(0, index), {
              ...state.kollegium[index],
              schuelerRaum: event.target.value
            },
            ...state.kollegium.slice(index + 1)
          ]
        });
      });
    };
  };

  handleSubmit(event) {
    if (event.target.name === "Passwort Abschicken") {
      this.setState(state => {
        if (state.eingabewert === passwort) {
          this.readKollegium(state.sortingKey, state.ascending);
          return ({
            aktivesMenue: "Administration"
          });
        }
        else {
          beep.play();
          alert("Fehler: Passwort falsch!");
          return ({
            aktivesMenue: "Hauptmenü"
          });
        };
      });
    };
  };

  sortObjects = (objects, sortingKey, ascending) => {
    if (typeof objects[0][sortingKey] === "number" || typeof objects[0][sortingKey] === "boolean") {
      objects.sort((a, b) => a[sortingKey] - b[sortingKey]);
    }
    else if (typeof objects[0][sortingKey] === "string") {
      objects.sort((a, b) => {
        if (a[sortingKey].toUpperCase() < b[sortingKey].toUpperCase()) {
          return -1;
        }
        else if (a[sortingKey].toUpperCase() > b[sortingKey].toUpperCase()) {
          return 1;
        }
        else {
          return 0;
        };
      });
    };
    if (!ascending) {
      objects.reverse();
    };
    return objects;
  };

  update = async () => {
    await this.readCounter();
    this.setState(state => {
      if (state.updateAlarm1) {
        this.readAlarm();
      };
      if (state.updateKollegium1) {
        if (state.aktivesMenue === "Meldung") {
          this.readKollegium("nachname", true);
        }
        else if (state.aktivesMenue === "Administration" || state.aktivesMenue === "BestaetigungReset") {
          this.readKollegium(state.sortingKey, state.ascending);
        };
      };
    });
  };

  createLehrer = async () => {
    try {
      const res = await fetch("/api/createlehrer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          success: true
        })
      });
      await res.json();
      await this.readKollegium(this.state.sortingKey, this.state.ascending);
    }
    catch {
      console.log("Fehler: Lehrer nicht erzeugt!");
    };
  };

  readCounter = async () => {
    try {
      const res = await fetch("/api/readcounter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          success: true
        })
      });
      const data = await res.json();
      this.setState(state => {
        if (data.counter !== state.counter) {
          state.updateAlarm2 = state.updateAlarm1;
          state.updateKollegium2 = state.updateKollegium1;
          state.updateAlarm1 = true;
          state.updateKollegium1 = true;
        }
        else {
          state.updateAlarm1 = false;
          state.updateAlarm2 = false;
          state.updateKollegium1 = false;
          state.updateKollegium2 = false;
        }
        return ({
          verbindungsabbruch: false,
          counter: data.counter,
          updateAlarm1: state.updateAlarm1,
          updateAlarm2: state.updateAlarm2,
          updateKollegium1: state.updateKollegium1,
          updateKollegium2: state.updateKollegium2
        });
      });
    }
    catch {
      this.setState({
        verbindungsabbruch: true,
        counter: 0,
        updateAlarm1: false,
        updateAlarm2: false,
        updateKollegium1: false,
        updateKollegium2: false
      });
      console.log("Fehler: Counter nicht geladen!");
    };
  };

  readAlarm = async () => {
    try {
      const res = await fetch("/api/readalarm", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          success: true
        })
      });
      const data = await res.json();
      this.setState(state => {
        return ({
          alarm: data.alarm,
          alarmNikolaus: data.alarmNikolaus,
          alarmLothar: data.alarmLothar,
          updateAlarm1: state.updateAlarm2
        });
      });
    }
    catch {
      this.setState({
        verbindungsabbruch: true,
        counter: 0,
        updateAlarm1: false,
        updateAlarm2: false,
        updateKollegium1: false,
        updateKollegium2: false
      });
      console.log("Fehler: Alarme nicht geladen!");
    };
  };

  readKollegium = async (sortingKey, ascending) => {
    try {
      const res = await fetch("/api/readkollegium", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          success: true
        })
      });
      const data = await res.json();
      this.setState(state => {
        return ({
          kollegium: this.sortObjects(data.kollegium, sortingKey, ascending),
          updateKollegium1: state.updateKollegium2
        });
      });
    }
    catch {
      this.setState({
        verbindungsabbruch: true,
        counter: 0,
        updateAlarm1: false,
        updateAlarm2: false,
        updateKollegium1: false,
        updateKollegium2: false
      });
      console.log("Fehler: Kollegium nicht geladen!");
    };
  };

  updateMeldung = async (meldung) => {
    try {
      const res = await fetch("/api/updatemeldung", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          meldung: meldung
        })
      });
      await res.json();
      alert("Meldung wurde erfolgreich gesendet. Vielen Dank!");
      this.setState({
        aktivesMenue: "Hauptmenü",
        meldung: {
          id: initialMeldung.id,
          standort: initialMeldung.standort,
          unterricht: initialMeldung.unterricht,
          jahrgang: initialMeldung.jahrgang,
          klasse: initialMeldung.klasse,
          klassenstaerke: initialMeldung.klassenstaerke,
          kurs: initialMeldung.kurs,
          schuelerVermisst: initialMeldung.schuelerVermisst,
          schuelerRaum: initialMeldung.schuelerRaum
        }
      });
    }
    catch {
      console.log("Fehler: Meldung nicht gesendet!");
      alert("Fehler: Meldung wurde nicht gesendet! Bitte erneut abschicken.");
    };
  };

  updateDoc = async (collection, id, dataName, dataValue) => {
    try {
      const res = await fetch("/api/updatedoc", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          collection: collection,
          id: id.toString(),
          dataName: dataName,
          dataValue: dataValue
        })
      });
      await res.json();
    }
    catch {
      console.log("Fehler: Daten nicht geändert!");
    };
  };

  resetMeldungen = async () => {
    try {
      const res = await fetch("/api/resetmeldungen", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          success: true
        })
      });
      await res.json();
      await this.readKollegium(this.state.sortingKey, this.state.ascending);
    }
    catch {
      console.log("Fehler: Meldungen nicht zurückgesetzt!");
    };
  };

  deleteDoc = async (collection, id) => {
    try {
      const res = await fetch("/api/deletedoc", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          collection: collection,
          id: id.toString()
        })
      });
      await res.json();
      await this.readKollegium(this.state.sortingKey, this.state.ascending);
    }
    catch {
      console.log("Fehler: Lehrer nicht gelöscht!");
    };
  };

  render() {
    if (this.state.verbindungsabbruch) {
      return (
        <Verbindungsabbruch />
      );
    }
    else {
      if (this.state.aktivesMenue === "Hauptmenü") {
        return (
          <Hauptmenue handleClick={this.handleClick} alarm={this.state.alarm} alarmNikolaus={this.state.alarmNikolaus} alarmLothar={this.state.alarmLothar} />
        );
      }
      else if (this.state.aktivesMenue === "Meldung") {
        return (
          <Meldung handleClick={this.handleClick} handleChange={this.handleChange} alarm={this.state.alarm} kollegium={this.state.kollegium} meldung={this.state.meldung} />
        );
      }
      else if (this.state.aktivesMenue === "Passworteingabe") {
        return (
          <Eingabeformular nameInput={"Passwort Eingabe"} nameSubmit={"Passwort Abschicken"} handleChange={this.handleChange} handleSubmit={this.handleSubmit} eingabewert={this.state.eingabewert} />
        );
      }
      else if (this.state.aktivesMenue === "Administration") {
        return (
          <Administration handleClick={this.handleClick} handleChange={this.handleChange} alarm={this.state.alarm} alarmNikolaus={this.state.alarmNikolaus} alarmLothar={this.state.alarmLothar} kollegium={this.state.kollegium} sortingKey={this.state.sortingKey} ascending={this.state.ascending} />
        );
      }
      else if (this.state.aktivesMenue === "BestaetigungReset") {
        return (
          <Bestaetigungsformular nameClick={"Reset"} handleClick={this.handleClick} bestaetigungsfrage={"Sollen die Meldungen wirklich zurückgesetzt werden?"} buttonsDisabled={false} />
        );
      };
    };
  };
};